import React,{useState} from "react";
import Select from "react-select";
import { Col, Row, Card, Form, Button} from "react-bootstrap";
import atlasApi from "../utils/atlasapi";
import { DownloadSimple} from "@phosphor-icons/react";

export default function ExportAllProjects({count}) {


	const formats = [
		{label: "Excel", value:"xlsx"},
		{label: "CSV", value:"csv"},
	]

	const [format, setFormat] = useState(formats[0]);
	const [active, setActive] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleDownload = () => {
		setLoading(true);
		atlasApi.downloadAllProjects(format.value).then((blob) => {
			const url = URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `projects.${format.value}`;
			document.body.appendChild(a);
			a.click();
			a.remove();
			URL.revokeObjectURL(url);
			setActive(false);
		}).catch((err) => {
			console.error(err);
		}).finally(() => {
			setLoading(false);
		});
	}

	return (
		<div className="download-all-projects">

			<Button variant={active ? "primary" : "outline-primary"} onClick={()=>{setActive(!active)}}><DownloadSimple size={16} /></Button>

			{!!active &&
			<Card className="options">

				<Card.Body className="card-form">
					<Row>
						<h6>Download project data</h6>
					</Row>
					<Row>
					<Col><small>Export all {count} projects</small></Col>
					</Row>
					<Row className="mt-3">
						<Form.Label>Format</Form.Label>
						<Select name="format" className="compact" components={{ IndicatorSeparator: null }} options={formats} defaultValue={formats[0]} onChange={(sel)=>setFormat(sel)}  isSearchable={false} placeholder="Format" />
					</Row>
					<Row className="mb-2 mt-4">
						<Col><Button size="sm" variant="outline-primary" onClick={()=>setActive(false)}>Cancel</Button></Col>
						<Col className="text-end"><Button size="sm" variant="primary" disabled={loading} onClick={handleDownload}>{loading ? 'Downloading...' : `Download as ${format.label}`}</Button></Col>
					</Row>
				</Card.Body>

			</Card>
			}
		</div>
	);
}